/* eslint-disable @stylistic/max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

type SearchAndFilterProps = {
	categories?: string[];
	searchTerm?: string;
	onSearchChange: (searchTerm: string) => void;
	onCategoryChange?: (selectedCategories: string[]) => void;
};

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
	categories,
	searchTerm,
	onSearchChange,
	onCategoryChange,
}) => {
	const [filterOpen, setFilterOpen] = useState(false);
	const [internalSearchTerm, setInternalSearchTerm] = useState('');
	const typeaheadRef = useRef<any>(null);
	const currentSearchTerm = searchTerm ?? internalSearchTerm;

	const toggleFilter = () => setFilterOpen((prev) => !prev);

	const handleBlur = () => {
		setTimeout(() => setFilterOpen(false), 150);
	};

	const updateSearchTerm = (nextSearchTerm: string) => {
		if (searchTerm === undefined) {
			setInternalSearchTerm(nextSearchTerm);
		}

		onSearchChange(nextSearchTerm);
	};

	return (
		<Row className="mb-3 local-bootstrap">
			<Col>
				<div className="position-relative mb-2">
					<Form.Control
						className="form-control mb-2"
						type="text"
						placeholder="Search..."
						value={currentSearchTerm}
						onChange={(e) => updateSearchTerm(e.target.value)}
					/>
					{currentSearchTerm.length > 0 && (
						<Button
							onClick={() => updateSearchTerm('')}
							className='position-absolute top-50 end-0 translate-middle-y bg-transparent border-0 text-body z-1'
							aria-label="Clear search"
						>
							<FontAwesomeIcon icon={faTimes} />
						</Button>
					)}
				</div>

			</Col>
			{
				(categories && onCategoryChange)
					? <Col>
						<div style={{ position: 'relative' }}>
							<Typeahead
								id="category-typeahead"
								multiple
								options={categories}
								onChange={(selected) => onCategoryChange(selected as string[])}
								placeholder="Filter by categories..."
								onFocus={() => setFilterOpen(true)}
								onBlur={handleBlur}
								open={filterOpen}
								ref={typeaheadRef}
							/>
							<Button
								onClick={() => {
									toggleFilter();
									if (!filterOpen) {
										typeaheadRef.current?.focus();
									}
								}}
								className='position-absolute top-50 end-0 translate-middle-y bg-transparent border-0 text-body z-1'
							>
								<FontAwesomeIcon icon={filterOpen ? faChevronDown : faChevronUp} />
							</Button>
						</div>
					</Col>
					: null
			}
		</Row>
	);
};

export default SearchAndFilter;
